

export default {
  scrollToTop: true,
  async asyncData({ app, store, error }) {
    if (!process.server) return
  },
  name: 'commonTitle',
  props: {
    title: {
      type: String,
      default: 'home.headTitle'
    },
    lineWidth: {
      type: String,
      default: '100%'
    },
    paddingBottom:{
      type: String,
      default: '57px'
    },
    showDashed: {
      type: Boolean,
      default: true
    },
    label:{
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: 'full-content-12'
    }
  },
  computed:{
    titleStr(){
      return this.$t(this.title)
    },
    labelStr(){
      return this.$t(this.label)
    },
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
